module.exports = __webpack_public_path__ + "img/resting_heart_rate_splash.298cf733.jpg";